


import type React from "react"
import { useState, useEffect, useMemo } from "react"
import {
  Typography,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Button,
  Box,
  Alert,
  Chip,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material"
import {
  PlayArrow,
  CheckCircle,
  School,
  Timer,
  Close,
  Quiz,
  VideoLibrary,
  Assignment,
  Download,
} from "@mui/icons-material"
// import { getCourses, startCourse, completeCourse } from "../../Services/OnboardingService2"
import styles from "./OnboardingCourses.module.css"
import { getCourses, startCourse, completeCourse } from "../../api/OnboardingService2"

interface OnboardingCoursesProps {
  employeeId: string
  isCompleted: boolean
  onComplete: () => void
}

interface Course {
  id: string
  course_id: string
  title: string
  description: string
  duration: string // Changed from number to string to match API
  type: "video" | "interactive" | "quiz" | "document"
  required: string | boolean // API returns "1" or "0" as strings
  status: string // API status for active/inactive
  content: string // URL for video/document content
  progress?: number
  score?: number
  completedDate?: string
  userStatus?: "not_started" | "in_progress" | "completed" // Track user's progress
}

const OnboardingCourses: React.FC<OnboardingCoursesProps> = ({ employeeId, isCompleted, onComplete }) => {
  const [courses, setCourses] = useState<Course[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null)
  const [courseDialogOpen, setCourseDialogOpen] = useState(false)
  const [courseContent, setCourseContent] = useState<any>(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [videoWatched, setVideoWatched] = useState(false)
  const [documentDownloaded, setDocumentDownloaded] = useState(false)
  const [completedCourseStatus, setCompletedCourseStatus] = useState<number | null>(null)

  useEffect(() => {
    fetchCourses()
    
  }, [employeeId])

  // const fetchCourses = async () => {
  //   try {
  //     setLoading(true)
  //     const data = await getCourses()
  //     console.log("Raw courses data:", data)

  //     // Filter only active courses (status === "1") and map to our interface
  //     const activeCourses = data
  //       .filter((course: any) => course.status === "1")
  //       .map((course: any) => ({
  //         id: course.id,
  //         course_id: course.course_id,
  //         title: course.title,
  //         description: course.description,
  //         duration: course.duration,
  //         type: course.type,
  //         required: course.required === "1" || course.required === true,
  //         status: course.status,
  //         content: course.content,
  //         userStatus: "not_started", // Default user status
  //         progress: 0,
  //       }))

  //     setCourses(activeCourses)
  //   } catch (err) {
  //     setError("Failed to load courses")
  //     console.error(err)
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const fetchCourses = async () => {
  try {
    setLoading(true)
    const data = await getCourses()

    // console.log("Raw courses data:", data)

    // const activeCourses = await Promise.all(
    //   data
    //     .filter((course: any) => course.status == "1")
    //     .map(async (course: any) => {
    //       let userStatus: Course["userStatus"] = "not_started"

    //       try {
    //         const res = await startCourse(course.course_id)
    //         if (res.status === 1) {
    //           userStatus = "completed"
    //           onComplete()
    //         }
    //       } catch (err) {
    //         console.warn(`Could not fetch status for course ${course.course_id}`, err)
    //       }

    //       return {
    //         id: course.id,
    //         course_id: course.course_id,
    //         title: course.title,
    //         description: course.description,
    //         duration: course.duration,
    //         type: course.type,
    //         required: course.required === "1" || course.required === true,
    //         status: course.status,
    //         content: course.content,
    //         userStatus,
    //         progress: userStatus === "completed" ? 100 : 0,
    //       }
    //     }),
    // )
onComplete()
    setCourses(data)
  } catch (err) {
    setError("Failed to load courses")
    console.error(err)
  } finally {
    setLoading(false)
  }
}


  const handleStartCourse = async (course: Course) => {
    try {
      console.log("Starting course:", course.course_id)
      const response = await startCourse(course.course_id)
      setCompletedCourseStatus(response.status)

      console.log("Course start response:", completedCourseStatus)
     
      // Update course status to in_progress
      setCourses(
        courses.map((c) =>
          c.course_id === course.course_id ? { ...c, userStatus: "in_progress" as const, progress: 0 } : c,
        ),
      )

      // Open course content dialog
      setSelectedCourse(course)
      setCourseDialogOpen(true)
    } catch (err) {
      setError("Failed to start course")
      console.error(err)
    }
  }

  const handleCompleteCourse = async (courseId: string, score?: number) => {
    try {
      await completeCourse(courseId, score)
      setCourses(
        courses.map((c) =>
          c.course_id === courseId
            ? {
                ...c,
                userStatus: "completed" as const,
                progress: 100,
                score,
                completedDate: new Date().toISOString(),
              }
            : c,
        ),
      )
      setCourseDialogOpen(false)

      // Check if all required courses are completed
      const updatedCourses = courses.map((c) =>
        c.course_id === courseId ? { ...c, userStatus: "completed" as const } : c,
      )
      const allRequiredCompleted = updatedCourses.filter((c) => c.required).every((c) => c.userStatus === "completed")

      if (allRequiredCompleted) {
        onComplete()
      }
    } catch (err) {
      setError("Failed to complete course")
      console.error(err)
    }
  }

  // const getYouTubeEmbedUrl = (url: string) => {
  //   const videoId = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)
  //   return videoId ? `https://www.youtube.com/embed/${videoId[1]}` : url
  // }
  const getYouTubeEmbedUrl = (url: string) => {
  const videoIdMatch = url.match(
    /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^&\n?#]+)/,
  )
  return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : url
}


  const handleDownloadDocument = (documentUrl: string, fileName: string) => {
    const link = document.createElement("a")
    link.href = documentUrl
    link.download = fileName
    link.target = "_blank"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setDocumentDownloaded(true)
  }

  const canCompleteCourse = (course: Course | null) => {
   
    if (!course) return false

    switch (course.type) {
      case "video":
        return !videoWatched
      case "document":
        return !documentDownloaded
      case "interactive":
      case "quiz":
        return true // Allow manual completion for interactive/quiz
      default:
        return true
    }
  }

  const getCourseIcon = (type: string, userStatus: string) => {
    if (userStatus === "completed") {
      return <CheckCircle color="success" />
    }

    switch (type) {
      case "video":
        return <VideoLibrary color={userStatus === "in_progress" ? "primary" : "disabled"} />
      case "quiz":
        return <Quiz color={userStatus === "in_progress" ? "primary" : "disabled"} />
      case "document":
        return <Assignment color={userStatus === "in_progress" ? "primary" : "disabled"} />
      default:
        return <School color={userStatus === "in_progress" ? "primary" : "disabled"} />
    }
  }

  const getStatusChip = (course: Course) => {
    switch (course.userStatus) {
      case "completed":
        return <Chip label={`Completed ${course.score ? `(${course.score}%)` : ""}`} color="success" size="small" />
      case "in_progress":
        return <Chip label={`${course.progress || 0}% Complete`} color="primary" size="small" />
      default:
        return <Chip label="Not Started" color="default" size="small" />
    }
  }

  // const getCompletedCoursesCount = () => {
  //   return courses.filter((course) => course.userStatus === "completed").length
  // }

  const completedCount = useMemo(() => {
  return courses.filter((course) => course.userStatus === "completed").length
}, [courses])


  const getRequiredCoursesCount = () => {
    return courses.filter((course) => course.required).length
  }

  const canComplete = () => {
    const requiredCourses = courses.filter((course) => course.required)
    return requiredCourses.every((course) => course.userStatus === "completed")
  }

  if (loading) {
    return (
      <Card className={styles.card}>
        <CardContent>
          <Typography>Loading courses...</Typography>
        </CardContent>
      </Card>
    )
  }

  if (error) {
    return (
      <Alert severity="error" className={styles.error}>
        {error}
      </Alert>
    )
  }

  // const completedCount = getCompletedCoursesCount()
  const requiredCount = getRequiredCoursesCount()

  return (
    <div className={styles.container}>
      <Card className={styles.progressCard}>
        <CardHeader
          title="Training Progress"
          subheader={`${completedCount}/${courses.length} courses completed`}
          action={
            isCompleted ? (
              <Chip label="All Courses Completed" color="success" icon={<CheckCircle />} />
            ) : (
              <Chip
                label={`${courses.filter((c) => c.required && c.userStatus === "completed").length}/${requiredCount} Required`}
                color={canComplete() ? "success" : "primary"}
              />
            )
          }
        />
      </Card>

      {isCompleted && (
        <Alert severity="success" className={styles.completedAlert}>
          <Typography variant="h6">Training Completed!</Typography>
          <Typography>You have successfully completed all required training courses.</Typography>
        </Alert>
      )}

      <Card className={styles.coursesCard}>
        <CardHeader title="Training Courses" subheader="Complete the following mandatory training courses" />
        <CardContent>
          <List className={styles.coursesList}>
            {courses.map((course) => (
              <ListItem key={course.course_id} className={styles.courseItem}>
                <ListItemIcon>{getCourseIcon(course.type, course.userStatus || "not_started")}</ListItemIcon>
                <ListItemText
                  primary={
                    <Box className={styles.courseHeader}>
                      <Typography variant="subtitle1">{course.title}</Typography>
                      <Box className={styles.courseMeta}>
                        {course.required && <Chip label="Required" size="small" color="error" />}
                        <Chip label={course.duration} size="small" icon={<Timer />} variant="outlined" />
                        <Chip label={course.type} size="small" color="primary" variant="outlined" />
                      </Box>
                    </Box>
                  }
                  secondary={
                    <Box>
                      <Typography variant="body2" color="textSecondary" className={styles.description}>
                        {course.description}
                      </Typography>
                      {course.userStatus === "in_progress" && (
                        <LinearProgress
                          variant="determinate"
                          value={course.progress || 0}
                          className={styles.progressBar}
                        />
                      )}
                      {course.completedDate && (
                        <Typography variant="caption" className={styles.completedDate}>
                          Completed: {new Date(course.completedDate).toLocaleDateString()}
                        </Typography>
                      )}
                    </Box>
                  }
                />
                <ListItemSecondaryAction className={styles.courseActions}>
                  {getStatusChip(course)}
                  <Button
                    variant={course.userStatus === "not_started" ? "contained" : "outlined"}
                    color="primary"
                    startIcon={course.userStatus === "completed" ? <CheckCircle /> : <PlayArrow />}
                    onClick={() => handleStartCourse(course)}
                    disabled={isCompleted || course.userStatus === "completed"}
                    className={styles.actionButton}
                  >
                    {course.userStatus === "completed"
                      ? "Review"
                      : course.userStatus === "in_progress"
                        ? "Continue"
                        : "Start"}
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      {/* Course Content Dialog */}
      <Dialog
        open={courseDialogOpen}
        onClose={() => setCourseDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        className={styles.courseDialog}
      >
        <DialogTitle className={styles.dialogTitle}>
          {/* <Typography variant="h6"> */}
            {selectedCourse?.title}
          {/* </Typography> */}
          <IconButton onClick={() => setCourseDialogOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={styles.dialogContent}>
          {selectedCourse && (
            <Box className={styles.courseContent}>
              <Typography variant="body1" className={styles.courseDescription}>
                {selectedCourse.description}
              </Typography>

              {/* Video Content */}
              {selectedCourse.type === "video" && selectedCourse.content && (
                <Box className={styles.videoContainer}>
                  {selectedCourse.content.includes("youtube.com") || selectedCourse.content.includes("youtu.be") ? (
                    <iframe
                      width="100%"
                      height="400"
                      src={getYouTubeEmbedUrl(selectedCourse.content)}
                      title={selectedCourse.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      onLoad={() => {
                        // Video loaded, enable completion after some time or user interaction
                        setTimeout(() => {
                          setVideoWatched(true)
                        }, 5000) // Enable completion after 5 seconds
                      }}
                    />
                  ) : (
                    <video width="100%" height="400" controls onEnded={() => setVideoWatched(true)}>
                      <source src={selectedCourse.content} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </Box>
              )}

              {/* Document Content */}
              {selectedCourse.type === "document" && selectedCourse.content && (
                <Box className={styles.documentContainer}>
                  <Typography variant="h6">Course Document</Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleDownloadDocument(selectedCourse.content, selectedCourse.title)}
                    startIcon={<Download />}
                    className={styles.downloadButton}
                  >
                    Download Course Material
                  </Button>
                  {documentDownloaded && (
                    <Alert severity="success" className={styles.downloadAlert}>
                      Document downloaded successfully! You can now complete the course.
                    </Alert>
                  )}
                </Box>
              )}

              {/* Interactive Content */}
              {selectedCourse.type === "interactive" && selectedCourse.content && (
                <Box className={styles.interactiveContainer}>
                  <Typography variant="h6">Interactive Course</Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.open(selectedCourse.content, "_blank")}
                    startIcon={<School />}
                    className={styles.interactiveButton}
                  >
                    Open Interactive Session
                  </Button>
                  <Typography variant="body2" color="textSecondary" className={styles.interactiveNote}>
                    Complete the interactive session and return here to mark as completed.
                  </Typography>
                </Box>
              )}

              {/* Quiz Content */}
              {selectedCourse.type === "quiz" && selectedCourse.content && (
                <Box className={styles.quizContainer}>
                  <Typography variant="h6">Quiz Assessment</Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.open(selectedCourse.content, "_blank")}
                    startIcon={<Quiz />}
                    className={styles.quizButton}
                  >
                    Take Quiz
                  </Button>
                  <Typography variant="body2" color="textSecondary" className={styles.quizNote}>
                    Complete the quiz and return here to mark as completed.
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCourseDialogOpen(false)}>Close</Button>
          {selectedCourse?.userStatus !== "completed" && (
            <Button
              variant="contained"
              color="success"
              onClick={() => selectedCourse && handleCompleteCourse(selectedCourse.course_id, 1)}
              disabled={!canCompleteCourse(selectedCourse)}
              startIcon={<CheckCircle />}
            >
              Mark as Completed
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default OnboardingCourses

